import { useContext } from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import messages from './messages';
import style from './style.module.less';
import Global from '../../../../../../src/store/global-selectors';
import { ReportsContext } from '../context';
import { ERROR_TYPE_GENERAL } from './../../constants';

const ErrorDisplay = () => {
  const { errorType, startDate, endDate } = useContext(ReportsContext);
  const userDateFormatString = useSelector(Global.selectUserUserDateFormat);
  const dateRangeString = `(${moment(startDate).format(userDateFormatString)} - ${moment(endDate).format(userDateFormatString)})`;
  const message = errorType === ERROR_TYPE_GENERAL ? messages.errorSubtext : messages.htmlTooLargeError;
  return (
    <BannerMessageV2
      className={style['form-error-message']}
      content={
        <>
          <div className={style['error-message']}>
            <FormattedMessage {...messages.errorMessage} />
          </div>
          <div className={style['error-subtext']}>
            <FormattedMessage {...message} values={{ errorSupplement: dateRangeString }} />
          </div>
        </>
      }
      status={BannerStatus.Error}
    />
  );
};

export default ErrorDisplay;
